import { Store } from '@betgames/bg-state-manager';
import { formatCurrencyTemplate } from '@betgames/bg-tools';
import { IGenericBet, ISingleBet } from '@bg-shared/business/Reports/interfaces_legacy/Bets';
import { partnerSettingsStore } from '@bg-shared/business/PartnerSettings';
import { sessionStore } from '../Session';

export default class RecentBetsStore extends Store<IGenericBet[]> {
    constructor() {
        super({
            key: 'RecentBets',
            default: [],
        });
    }

    public saveBetsList(bets: IGenericBet[]): void {
        this.update(
            bets
                .filter((bet) => {
                    const { gameId } = bet as ISingleBet;
                    return !(gameId && !partnerSettingsStore.availableGamesIds.includes(gameId));
                })
                .map((bet) => ({
                    ...bet,
                    currencyFormatter: formatCurrencyTemplate(
                        bet?.currencyTemplate,
                        sessionStore.currency?.precision,
                    ),
                })),
        );
    }

    public saveBet(newBet: IGenericBet): void {
        newBet.currencyFormatter = formatCurrencyTemplate(
            newBet?.currencyTemplate,
            sessionStore.currency?.precision,
        );

        this.update((draft) => {
            if (!draft.length) {
                draft.push(newBet);
            } else {
                const existingBet = draft.find((bet) => bet.id === newBet.id);

                if (existingBet) {
                    Object.assign(existingBet, newBet);
                } else {
                    const latestBetTimestamp = new Date(draft[0].time);
                    const newBetTimestamp = new Date(newBet.time);

                    if (newBetTimestamp >= latestBetTimestamp) {
                        draft.unshift(newBet);
                    }
                }
            }
        });
    }

    public saveBatchBets(bets: IGenericBet[]): void {
        bets.forEach((newBet) => {
            this.saveBet({ ...newBet });
        });
    }

    public removeBet(betId: number): void {
        this.update(this.value.filter((bet) => bet.id !== betId));
    }
}

export const recentBetsStore = new RecentBetsStore();
